export const data = [
    {
        "title": "Rutgers Chatbot",
        "description": "A conversational A.I. built for Rutgers Course Planning.",
        "link": "https://github.com/MugPand/RutgersChatbot",
        "technologies": "Python, React, JavaScript, sklearn, NumPy, SQL, Pandas",
        "image": "rutgersLogo.svg",
    },
    {
        "title": "eq",
        "description": "A simple social media template website originally built to be a distraction-free social forum where users could chat about emotions, get advice, and connect with others.",
        "link": "https://github.com/MugPand/eq",
        "technologies": "Built using Next.js, React, TypeScript, Tailwind, Firebase Authentication and Firebase Firestore.",
        "image": "eqLogo.png",
    },
    {
        "title": "Car Brand Identification in Noisy Images using CNNs",
        "description": "Developed an AutoEncoder & fine-tuned ResNet to identify make, model, and year of cars in noisy images that simulated real-world conditions.",
        "link": "https://github.com/rohitamar/IdentifyingCarBrandsNoisyImagesCNN",
        "technologies": "Python, PyTorch, NumPy, Pandas, ResNet",
        "image": "noisyCar.png",
    },
    {
        "title": "Path Visualizer",
        "description": "Pygame based GUI application that allows users to draw mazes, i.e. mark cells as free or blocked, and run BFS or DFS on them to find paths between a start & end cell.",
        "link": "https://github.com/MugPand/Path-Visualizer",
        "technologies": "Python, Pygame",
        "image": "pathVisualizerLogo.jpg",
    },
    {
        "title": "2D-Ray-Casting",
        "description": "Ray visualizer built in python using the pygame library that allows users to move a light source around and cast the appropriate rays onto walls.",
        "link": "https://github.com/MugPand/2D-Ray-Casting",
        "technologies": "Python, Pygame",
        "image": "2DRayCastingLogo.jpg",
    },
    {
        "title": "AlzCheck",
        "description": "HackRU Fall 2020 winning health track submission. An informative/training website to help individuals diagnosed with Alzheimer's.",
        "link": "https://github.com/MugPand/Alz-Check",
        "technologies": "HTML/CSS, JavaScript, Bootstrap, Google Maps API, Unity",
        "image": "AlzCheckLogo.png",
    },
    {
        "title": "HeadlinerBot",
        "description": "Discord bot that pings twitter accounts to keep servers up to date with breaking headlines.",
        "link": "https://github.com/MugPand/HeadlinerBot",
        "technologies": "Python, Discord API, Twitter API",
        "image": "headliner.png",
    },
    {
        "title": "Pyshell",
        "description": "Unix Shell developed in Python.",
        "link": "https://github.com/MugPand/Pyshell",
        "technologies": "Python",
        "image": "pyshell.webp",
    },
];